import { render, staticRenderFns } from "./editCommodity.vue?vue&type=template&id=8dd57760&scoped=true&"
import script from "./editCommodity.vue?vue&type=script&lang=js&"
export * from "./editCommodity.vue?vue&type=script&lang=js&"
import style0 from "./editCommodity.vue?vue&type=style&index=0&id=8dd57760&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8dd57760",
  null
  
)

component.options.__file = "editCommodity.vue"
export default component.exports